module.exports = __webpack_public_path__ + "img/homework-bjg.7403cd6a.png";